import { render, staticRenderFns } from "./CmpFooter.vue?vue&type=template&id=43ce230f"
import script from "./CmpFooter.vue?vue&type=script&lang=js"
export * from "./CmpFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports